import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FinancialStatementLayout from '../common/financial-statement-table/FinancialStatementLayout';
import { TABS } from '../Const';
import { fetchCashFlowStatement, REDUCER_NAME } from '../reducer';
import Chart from './Chart';

class CashFlowStatement extends PureComponent {
  getDataFromRedux = state => {
    try {
      const { timeKey, componentId } = this.props;

      return state[REDUCER_NAME][componentId].cashFlowStatement.data[timeKey]
        .dataByIds;
    } catch (e) {
      return {};
    }
  };

  render() {
    const {
      isLoading,
      ids,
      fields,
      timeKey,
      dataByIds,
      fetchCashFlowStatement,
      organCode,
      locale,
      size,
      componentId,
      rawData,
    } = this.props;

    return (
      <FinancialStatementLayout
        timeKey={timeKey}
        getDataFromRedux={this.getDataFromRedux}
        isLoading={isLoading}
        rawData={rawData}
        ids={ids}
        tab={TABS.CASH_FLOW_STATEMENT}
        fields={fields}
        fetchData={fetchCashFlowStatement}
        dataByIds={dataByIds}
        organCode={organCode}
        componentId={componentId}
      >
        {(skip, numberColumn) => (
          <Chart
            numberColumn={numberColumn}
            locale={locale}
            timeKey={timeKey}
            width={size.width}
            fields={fields}
            dataByIds={dataByIds}
            skip={skip}
          />
        )}
      </FinancialStatementLayout>
    );
  }
}

const defaultProps = {
  ids: [],
  fields: [],
  dataByIds: {},
  isLoading: false,
  size: {},
  locale: '',
};

CashFlowStatement.propTypes = {
  fetchCashFlowStatement: PropTypes.func.isRequired,
  ids: PropTypes.array.isRequired,
  organCode: PropTypes.string,
  timeKey: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  i18nPrefix: PropTypes.string,
  size: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  componentId: PropTypes.number.isRequired,
};

const mapStateToProps = (state, { timeKey, componentId }) => {
  try {
    return {
      ids: state[REDUCER_NAME][componentId].cashFlowStatement.data[timeKey].ids,
      fields:
        state[REDUCER_NAME][componentId].cashFlowStatement.data[timeKey].fields,
      dataByIds:
        state[REDUCER_NAME][componentId].cashFlowStatement.data[timeKey]
          .dataByIds,
      isLoading: state[REDUCER_NAME][componentId].cashFlowStatement.isLoading,
      rawData: state[REDUCER_NAME][componentId].cashFlowStatement.rawData,
      size: state[REDUCER_NAME][componentId].size,
      skip: state[REDUCER_NAME][componentId].skip,
      locale: state.i18n.locale,
    };
  } catch (e) {
    return defaultProps;
  }
};

const mapDispatchToProps = {
  fetchCashFlowStatement,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CashFlowStatement);
